// import * as actionType from '../action';

const initialState = {
  multiNavigation: [
    {
      id: 1,
      navTitle: 'Title1',
      subTitle: ['subTitle1', 'subTitle2'],
      navLink: ['#link1', '#link2'],
    },
    {
      id: 2,
      navTitle: 'Title1',
      subTitle: ['subTitle1', 'subTitle2'],
      navLink: ['#link1', '#link2'],
    },
  ],
  singleNavigation: [
    {
      id: 1,
      navTitle: 'Title',
      navLink: '#title',
    },
  ],
};

const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return {
        ...state,
      };
  }
};

export default navigationReducer;
